export default {
  title: {
    id: 'bo_sellers-orders-drawers-import_csv_file-tracking_numbers_info_title',
    defaultMessage:
      'Upload your tracking numbers to ship your to-be-shipped orders',
  },
  infoBlockTitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-info_block_title',
    defaultMessage: 'Upload a CSV file formatted in {count} separate columns:',
  },
  infoBlockSubtitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-info_block_sub_title',
    defaultMessage:
      'Only orders with the status “To-be-shipped” will be updated.',
  },
  infoBlockLine1: {
    id: 'bo_sellers-orders-drawers-import_csv_file-order_id',
    defaultMessage: 'order_id (mandatory)',
  },
  infoBlockLine2: {
    id: 'bo_sellers-orders-drawers-import_csv_file-tracking_number',
    defaultMessage: 'tracking_number (mandatory)',
  },
  infoBlockLine3: {
    id: 'bo_sellers-orders-drawers-import_csv_file-tracking_url',
    defaultMessage: 'tracking_url (optional)',
  },
  infoBlockLine4: {
    id: 'bo_sellers-orders-drawers-import_csv_file-shipper',
    defaultMessage: 'shipper (optional)',
  },
} as const
